import { createContext, useContext, useState, ReactNode } from 'react';

interface NotionTaskModalContextType {
  isOpen: boolean;
  pageId: string | null;
  notionLink: string | null;
  openModal: (pageId: string, notionLink?: string) => void;
  closeModal: () => void;
}

const NotionTaskModalContext = createContext<NotionTaskModalContextType | undefined>(undefined);

export function NotionTaskModalProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [pageId, setPageId] = useState<string | null>(null);
  const [notionLink, setNotionLink] = useState<string | null>(null);

  const openModal = (id: string, link?: string) => {
    setPageId(id);
    setNotionLink(link || null);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setPageId(null);
    setNotionLink(null);
  };

  return (
    <NotionTaskModalContext.Provider
      value={{
        isOpen,
        pageId,
        notionLink,
        openModal,
        closeModal,
      }}
    >
      {children}
    </NotionTaskModalContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components -- hook de contexto fica junto do Provider
export function useNotionTaskModal() {
  const context = useContext(NotionTaskModalContext);
  if (context === undefined) {
    throw new Error('useNotionTaskModal must be used within a NotionTaskModalProvider');
  }
  return context;
}

